module.exports = __webpack_public_path__ + "img/right-arrow-disabled.1c7e49da.svg";